import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { updateUser } from '../users/makeUserSlice'

const initialState = {
  status: '',
  allUsers: [],
  loading: false,
  error: '',
  localProjectMap: {},
}

export const getAllUsers = createAsyncThunk('getAllUsers', async role => {
  try {
    if (!role) {
      role = 'all'
    }
    const res = await axios.get(
      `${process.env.REACT_APP_HUMBLEBEE_API_URL}/users?limit=10000&role=${role}`
    )
    console.log('res.data from Users ==> ', res.data)
    return res.data.userInfo
  } catch (error) {
    console.log('error while fetching all users ', error)
    return error.response.data
  }
})

const getAllUsersSlice = createSlice({
  name: 'getAllUsers',
  initialState,
  reducers: {},

  extraReducers: builder => {
    builder
      .addCase(getAllUsers.pending, (state, action) => {
        state.loading = true
        state.error = ''
      })
      .addCase(getAllUsers.fulfilled, (state, { payload, error }) => {
        state.loading = false
        if (error) {
          console.log('error in getAllUsers fullfilled ', error)
          state.error = error
        } else {
          console.log('payload in getAllUsers fullfilled ', payload)
          const mergedUsers = (payload || []).map(user => {
            const uId = user._id || user.userInfo?._id
            const assignedProjId = state.localProjectMap[String(uId)]
            if (assignedProjId) {
              if (user.userInfo) {
                return {
                  ...user,
                  userInfo: {
                    ...user.userInfo,
                    projectId: assignedProjId,
                    fieldViewData:
                      user.userInfo.fieldViewData &&
                      user.userInfo.fieldViewData.length > 0
                        ? [
                            {
                              ...user.userInfo.fieldViewData[0],
                              project_id: assignedProjId,
                            },
                            ...user.userInfo.fieldViewData.slice(1),
                          ]
                        : [{ project_id: assignedProjId }],
                  },
                }
              } else {
                return {
                  ...user,
                  projectId: assignedProjId,
                  fieldViewData:
                    user.fieldViewData && user.fieldViewData.length > 0
                      ? [
                          {
                            ...user.fieldViewData[0],
                            project_id: assignedProjId,
                          },
                          ...user.fieldViewData.slice(1),
                        ]
                      : [{ project_id: assignedProjId }],
                }
              }
            }
            return user
          })
          state.allUsers = mergedUsers
        }
      })
      .addCase(getAllUsers.rejected, (state, { message }) => {
        state.error = message
        state.loading = false
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        const updatedUserPayload = action.meta?.arg?.userInfo
        if (updatedUserPayload && updatedUserPayload._id) {
          const uId = String(updatedUserPayload._id)
          if (updatedUserPayload.projectId) {
            state.localProjectMap[uId] = updatedUserPayload.projectId
          }
          state.allUsers = state.allUsers.map(user => {
            const currentId = user._id || user.userInfo?._id
            if (String(currentId) === uId) {
              if (user.userInfo) {
                return {
                  ...user,
                  userInfo: {
                    ...user.userInfo,
                    ...updatedUserPayload,
                    projectId: updatedUserPayload.projectId,
                    fieldViewData:
                      updatedUserPayload.fieldViewData ||
                      user.userInfo.fieldViewData,
                  },
                }
              } else {
                return {
                  ...user,
                  ...updatedUserPayload,
                  projectId: updatedUserPayload.projectId,
                  fieldViewData:
                    updatedUserPayload.fieldViewData || user.fieldViewData,
                }
              }
            }
            return user
          })
        }
      })
  },
})

export default getAllUsersSlice.reducer
